import styled from "styled-components"
import { hideVisually } from "polished"

const HiddenHeading = styled.h2`
  ${hideVisually()}
`

export default HiddenHeading
